var map = {
	"./big-mac-meal.png": 2112,
	"./big-mac-modal.png": 4142,
	"./big-mac.png": 6654,
	"./cheese.png": 827,
	"./chips-coke.png": 9708,
	"./coke-and-chips-redeem.png": 6539,
	"./drip.svg": 2603,
	"./enter-code-and-redeem.png": 2483,
	"./got-a-voucher.png": 5119,
	"./home-burger.png": 2951,
	"./home-cheese.png": 1567,
	"./home-lettuce.png": 4672,
	"./lettuce.png": 508,
	"./patty-pickles.png": 3034,
	"./pickles.png": 2811,
	"./recording-btn.png": 1552,
	"./retry-pickles.png": 2650,
	"./sauce-blob.png": 163,
	"./sound-wave.png": 8861,
	"./tap-more.png": 1019,
	"./top-bun.png": 3711,
	"./words.png": 5965,
	"./xmark.svg": 9693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7759;